const initialState = {
    data: [],
  };
  
  const glosowanieKartyReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_GLOSOWANIE_KARTY':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default glosowanieKartyReducer;